import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconScheduler from './nav-icon-scheduler.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconScheduler {...validProps} />;
}
SvgComponent.iconName = 'navIconScheduler';

export const NavIconSchedulerIcon = svgIconWrapper(SvgComponent);
